/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import SearchModel from "../SearchModel";
import { callConfigExit } from "../error/callConfigExit";
import { NavigationTarget, NavigationTracker } from "../sinaNexTS/sina/NavigationTarget";

export function generateCustomNavigationTracker(model: SearchModel): NavigationTracker {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (navigationTarget: NavigationTarget) => {
        callConfigExit(
            "beforeNavigation",
            model.config.applicationComponent,
            () => model.config.beforeNavigation(model),
            model.errorHandler
        );
    };
}
